/**
 *  2020/9/28
 *  通知公告
 */
import *as utils from '../utils'
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';
let headers = {
    "Content-Type": 'application/json;charset=UTF-8'
};
let cacheAndcredentials = {cache: 'no-cache', /*credentials: 'include'*/};
//host = 'http://192.168.220.6:7898/cm-sites-media-matrix-service/';
const Apis = {
    getAllNotification: host + 'notification/getAllNotification',//获取通知公告列表
    delNotificationById: host + 'notification/delNotificationById',//删除公告
    backNotificationById: host + 'notification/backNotificationById',//撤回公告
    getNotificationReceiverByAccountAndStatus: host + 'notification/getNotificationReceiverByAccountAndStatus',//获取通知公告列表contrbute
    getDeptList: host + 'dept/list',//获取部门
    getUserAllList: host + 'user/alllist',//获取人员
    addNotification: host + 'notification/addNotification',//新增
    editNotification: host + 'notification/editNotification',//编辑
    getAttachmentFile: host + 'notification/getAttachmentFile',//根据id获取附件
    getNotificationById: host + 'notification/getNotificationById',//根据id获取详情
    viewNotification: host + 'notification/viewNotification',//contribute预览




};


//获取公告列表
export function getAllNotification(body, callBack) {
    let url = Apis.getAllNotification + utils.params(body)+'&time='+new Date().getTime();
    ;
    fetch(url, {
        method: 'get',
        ...cacheAndcredentials
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getAllNotification", error);
        callBack({});
    })
}

//获取公告列表contribute
export function getNotificationReceiverByAccountAndStatus(body, callBack) {
    let url = Apis.getNotificationReceiverByAccountAndStatus + utils.params(body)+'&time='+new Date().getTime();
    ;
    fetch(url, {
        method: 'get',
        ...cacheAndcredentials
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getNotificationReceiverByAccountAndStatus", error);
        callBack({});
    })
}

//删除公告
export function delNotificationById(body, callBack) {
    let url = Apis.delNotificationById+'?time='+new Date().getTime();
    fetch(url, {
        method: 'post',
        ...cacheAndcredentials,
        body: body,
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:delNotificationById", error);
        callBack({});
    })
}

//撤回公告
export function backNotificationById(body, callBack) {
    let url = Apis.backNotificationById+'?time='+new Date().getTime();
    fetch(url, {
        method: 'post',
        ...cacheAndcredentials,
        body: body,
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:backNotificationById", error);
        callBack({});
    })
}

//获取部门列表
export function getDeptList( callBack) {
    let url = Apis.getDeptList+'?time='+new Date().getTime();
    fetch(url, {
        method: 'get',
        ...cacheAndcredentials
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getDeptList", error);
        callBack({});
    })
}

//获取人员列表
export function getUserAllList( body,callBack) {
    let url = Apis.getUserAllList+ utils.params(body)+'&time='+new Date().getTime();
    fetch(url, {
        method: 'get',
        ...cacheAndcredentials
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getUserAllList", error);
        callBack({});
    })
}

//新增公告
export function addNotification( body,callBack) {
    let url = Apis.addNotification+'?time='+new Date().getTime();
    fetch(url, {
        method: 'post',
        ...cacheAndcredentials,
        body: body,
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:addNotification", error);
        callBack({});
    })
}

//编辑公告
export function editNotification( body,callBack) {
    let url = Apis.editNotification+'?time='+new Date().getTime();
    fetch(url, {
        method: 'post',
        ...cacheAndcredentials,
        body: body,
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:editNotification", error);
        callBack({});
    })
}

//根据id,获取附件
export function getAttachmentFile( body,callBack) {
    let url = Apis.getAttachmentFile+'?time='+new Date().getTime();
    fetch(url, {
        method: 'post',
        ...cacheAndcredentials,
        body: body,
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getAttachmentFile", error);
        callBack({});
    })
}

//根据id,获取详情
export function getNotificationById( body,callBack) {
    let url = Apis.getNotificationById+'?time='+new Date().getTime();
    fetch(url, {
        method: 'post',
        ...cacheAndcredentials,
        body: body,
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getNotificationById", error);
        callBack({});
    })
}
//预览
export function viewNotification( body,callBack) {
    let url = Apis.viewNotification+'?time='+new Date().getTime();
    fetch(url, {
        method: 'post',
        ...cacheAndcredentials,
        body: body,
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getNotificationById", error);
        callBack({});
    })
}